import { Button, Col, Form, Input, Row } from 'antd';
import greenTick from '../assets/icon/bigGreenMark.svg';
import React from 'react';
import email from '../assets/icon/email.svg';
import phone from '../assets/icon/phone-call.svg';
import {
  useGetInTouchMutation,
  useRequestDemoMutation,
} from '../promotionSlice';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import moment from 'moment';

function ContactModal({ activeState, setState }) {
  let isForm = activeState === 'contact' || activeState === 'demo';
  let isSucess =
    activeState === 'contactSuccess' || activeState === 'demoSuccess';

  const [getInTouch, { isLoading: inTouchLoading }] = useGetInTouchMutation();
  const [requestDemo, { isLoading: demoLoading }] = useRequestDemoMutation();
  const [date, setDate] = React.useState(dayjs(new Date()));
  const [time, setTime] = React.useState(dayjs(new Date()));

  const handleFormSubmit = (formData) => {
    if (activeState === 'contact') {
      getInTouch(formData)
        .unwrap()
        .then(() => {
          setState((ps) => ({ ...ps, value: 'contactSuccess' }));
        });
    } else {
      requestDemo({
        ...formData,
        preferred_demo_date: `${moment(date?.$d)
          .local()
          .format('YYYY-MM-DD')} ${moment(time?.$d).local().format('HH:mm')}`,
      })
        .unwrap()
        .then(() => {
          setState((ps) => ({ ...ps, value: 'demoSuccess' }));
        });
    }
  };

  return (
    <div>
      {isForm && (
        <div>
          <h2 className='white txt-center fs-30 gBold'>
            {activeState === 'contact' ? "Let's Talk " : 'Schedule Demo'}
          </h2>
          <p className='fs-18 gMedium sb-blue-100 txt-center'>
            {activeState === 'contact'
              ? 'A member of our team will be in touch to answer your questions and go through your specific requirements.'
              : 'Schedule a provisional demo time and a member of our team will be in touch to confirm and go through your specific requirements.'}
          </p>
          <Form
            name='contact'
            className='mg-bottom-20'
            onFinish={handleFormSubmit}
          >
            <div className='form-field-container'>
              <div>
                <p className='gBold mg-bottom-0 sb-blue-100'>Full Name*</p>

                <Form.Item
                  className='mg-bottom-15'
                  name='name'
                  rules={[{ required: true, message: 'Please fill your name' }]}
                >
                  <Input className='gSemiBold br5' />
                </Form.Item>
              </div>
              <div>
                <p className='gBold mg-bottom-0 sb-blue-100'>
                  Fishery/Lake Name*
                </p>

                <Form.Item
                  className='mg-bottom-15'
                  name='fishery_name'
                  rules={[
                    { required: true, message: 'Please fill your lake name' },
                  ]}
                >
                  <Input className='gSemiBold br5' />
                </Form.Item>
              </div>
              <div>
                <p className='gBold mg-bottom-0 sb-blue-100'>Email Address*</p>

                <Form.Item
                  className='mg-bottom-15'
                  name='email'
                  rules={[
                    {
                      required: true,
                      type: 'email',
                      message: 'Please fill correct email',
                    },
                  ]}
                >
                  <Input type='email ' className='gSemiBold br5' />
                </Form.Item>
              </div>
              <div>
                <p className='gBold mg-bottom-0 sb-blue-100'>
                  Best Contact Number*
                </p>

                <Form.Item
                  className='mg-bottom-15'
                  name='phone_number'
                  rules={[
                    {
                      required: true,
                      message: 'Please fill your number',
                    },
                  ]}
                >
                  <Input
                    type='number'
                    className='gSemiBold br5'
                    onKeyDown={(e) => {
                      // Allow numeric characters, backspace, delete, arrow keys, and tab
                      if (
                        !(
                          (
                            (e.keyCode >= 48 && e.keyCode <= 57) || // 0-9
                            (e.keyCode >= 96 && e.keyCode <= 105) || // numpad 0-9
                            e.keyCode === 8 || // backspace
                            e.keyCode === 46 || // delete
                            e.keyCode === 37 || // left arrow
                            e.keyCode === 39 || // right arrow
                            e.keyCode === 9
                          ) // tab
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </div>
              {activeState === 'demo' && (
                <>
                  <div>
                    <p className='gBold mg-bottom-0 sb-blue-100'>
                      Preferred Demo Date
                    </p>

                    <Form.Item
                      className='mg-bottom-15 demo-date'
                      name='preferred_demo_date'
                      rules={[{ message: 'Please fill date' }]}
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          //   size='large'
                          value={date}
                          style={{ fontFamily: 'gRegular', color: 'white' }}
                          onChange={(value) => {
                            if (value) {
                              setDate(value);
                            }
                          }}
                          slotProps={{
                            textField: {
                              size: 'small',
                              error: !date,
                            },
                          }}
                          className='br5 gRegular w-full bg-white'
                          id='gRegular'
                          format={'dddd D  MMMM YYYY'}
                        ></DatePicker>
                      </LocalizationProvider>
                    </Form.Item>
                  </div>
                  <div>
                    <p className='gBold mg-bottom-0 sb-blue-100'>
                      Preferred Demo Time
                    </p>

                    <Form.Item
                      className='mg-bottom-15 demo-date'
                      name='preferred_demo_time'
                      rules={[{ message: 'Please fill date' }]}
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          size='large'
                          slotProps={{ textField: { size: 'small' } }}
                          value={time}
                          onChange={(value) => {
                            setTime(value);
                          }}
                          className='br5 gRegular bg-white w-full'
                          format={'HH:mm'}
                        ></TimePicker>
                      </LocalizationProvider>
                    </Form.Item>
                  </div>
                </>
              )}
            </div>
            <Button
              className='submit-button gBold mg-top-20'
              htmlType='submit'
              loading={inTouchLoading || demoLoading}
            >
              Submit
            </Button>
          </Form>
          <Row gutter={[10, 10]} className='pd-20  justify-between center'>
            <Col className='white fs-16 gSemiBold center' span={24} md={11}>
              <div className='row-center justify-center'>
                <img src={email} alt='email' className='mg-right-10' />
                <div>info@swimbooker.com</div>
              </div>
            </Col>
            <Col className='white fs-16 gSemiBold' span={24} md={11}>
              <div className='row-center justify-center'>
                <img src={phone} alt='phone' className='mg-right-10' />
                <div>+44 (0) 208 194 9396</div>
              </div>
            </Col>
          </Row>
        </div>
      )}
      {isSucess && (
        <div>
          <div className='white txt-center fs-30 gBold mg-bottom-15'>
            Great! We’ll be in touch.
          </div>
          <div className='center mg-bottom-15'>
            <img src={greenTick} alt='greenTick' />
          </div>
          <div className='sb-blue-100 fs-20 gMedium txt-center'>
            {activeState === 'contactSuccess'
              ? 'Thank you for submitting interest in The Fishery Manager. A member of our team will be in touch shortly to discuss further.'
              : 'Thank you for submitting interest in The Fishery Manager. A member of our team will be in touch to confirm your demo shortly.'}
          </div>
          <Button
            className='submit-button gBold mg-top-20'
            onClick={() => setState((ps) => ({ ...ps, state: false }))}
          >
            Close
          </Button>
        </div>
      )}
    </div>
  );
}

export default ContactModal;
